<template>
  <cs-preloader-overlay :loading="loading">
    <div
      ref="mainContainer"
      :class="$style.container"
    >
      <div
        :class="isActiveReferralProgram ? $style.activeReferralProgram : $style.inactiveReferralProgram"
      >
        <navigation-tabs
          v-if="isActiveReferralProgram"
        ></navigation-tabs>

        <project-layout shown-create>
          <project-card
            v-for="project in projects"
            :key="project.projectId"
            :project="project"
          />
        </project-layout>

        <img
          v-if="loadingPush"
          src="@/assets/img/loader.svg"
        />
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { fetch as fetchPartner } from 'services/partner';

import Partnership from 'services/partner/Partnership';

import NavigationTabs from 'organisms/reports/components/NavigationTabs';
import ProjectLayout from 'organisms/reports/components/ProjectLayout';
import ProjectCard from 'organisms/reports/components/ProjectCard';

import HTTPService from '@/services/Http';

export default {
  name: 'ProjectList',
  components: {
    NavigationTabs,
    ProjectLayout,
    ProjectCard,
  },
  async created() {
    this.loading = true;

    this.partner = new Partnership();
    this.partner.setData(await fetchPartner());
    await this.loadNextPage();

    this.loading = false;
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },
  data() {
    return {
      loading: false,
      loadingPush: false,
      pageSize: 20,
      isEndPage: false,
      page: 0,
      partner: new Partnership(),
      projects: [],
    };
  },
  computed: {
    isActiveReferralProgram() {
      return this.partner.isActive();
    },
    ...mapGetters(['PROJECT_LIST']),
  },

  methods: {
    ...mapMutations([
      'SET_SCROLL_STATES',
    ]),

    async loadNextPage() {
      if (this.loadingPush || this.isEndPage) {
        return;
      }
      this.loadingPush = true;
      try {
        this.page++;
        const projectList = await HTTPService.getPersonalProjects(this.page);
        this.projects.push(...projectList);
        // this.partner.pushChildProjects(projectList);
        this.isEndPage = projectList.length < this.pageSize;
      } finally {
        this.loadingPush = false;
      }
    },

    scrollHandler() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset || 0;
      let offset = scrollTop + window.innerHeight;
      let height = document.documentElement.offsetHeight;

      // load and push transactions when reaches bottom
      let heightFactor = 100;
      if (offset + heightFactor >= height && !this.loadingPush) {
        this.loadNextPage();
      }

      // filters block
      let arrangerRect = this.$refs.mainContainer.getBoundingClientRect();
      let arrangerOffset = arrangerRect.top;

      this.SET_SCROLL_STATES({
        type: 'ProjectList_block_is_fixed',
        params: arrangerOffset <= 5,
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative
    z-index: 2000

  .activeReferralProgram
    width: 100%
    max-width: 620px
    position: relative
    margin: 0 auto

    +respond-to('medium')
      top: -100px

  .inactiveReferralProgram
    width: 100%
    max-width: 620px
    margin: 20px auto 0 auto

    +respond-to(small)
      margin: 0 auto
</style>
